import { render, staticRenderFns } from "./ExtranetHeader.vue?vue&type=template&id=dde2223c&scoped=true"
import script from "./ExtranetHeader.vue?vue&type=script&lang=js"
export * from "./ExtranetHeader.vue?vue&type=script&lang=js"
import style0 from "./ExtranetHeader.vue?vue&type=style&index=0&id=dde2223c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde2223c",
  null
  
)

export default component.exports